var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        visible: _vm.internalVisible,
        title: "" + _vm.title + (_vm.isAdd ? "報價單" : "客戶資料"),
        top: "5vh",
        width: "30%",
        "append-to-body": "",
        "show-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.internalVisible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "leader-data" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "dynamicValidateForm",
                        attrs: {
                          model: _vm.formData,
                          disabled: !_vm.authEdit && !_vm.isAdd,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "負責業務員",
                              "label-width": _vm.formLabelWidth,
                              prop: "saleerID",
                              rules: [
                                {
                                  required: true,
                                  message: "請選擇負責業務員",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "請選擇",
                                    },
                                    model: {
                                      value: _vm.formData.saleerID,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "saleerID", $$v)
                                      },
                                      expression: "formData.saleerID",
                                    },
                                  },
                                  _vm._l(_vm.saleerList, function (item) {
                                    return _c("el-option", {
                                      key: item.nickName,
                                      attrs: {
                                        label:
                                          item.name +
                                          " " +
                                          (item.nickName
                                            ? "(" + item.nickName + ")"
                                            : ""),
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _c("el-button", {
                                  attrs: {
                                    type: "warning",
                                    icon: "el-icon-plus",
                                    size: "mini",
                                    loading: _vm.loading,
                                  },
                                  on: { click: _vm.handleCreateSaleer },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        !_vm.isAdd && _vm.formData.travelerName
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "旅客名稱",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "travelerName",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入旅客名稱",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "請輸入旅客名稱" },
                                  model: {
                                    value: _vm.formData.travelerName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "travelerName",
                                        $$v
                                      )
                                    },
                                    expression: "formData.travelerName",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isAdd && _vm.formData.travelerName
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "旅客職稱",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "travelerJob",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "請輸入旅客職稱" },
                                  model: {
                                    value: _vm.formData.travelerJob,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "travelerJob", $$v)
                                    },
                                    expression: "formData.travelerJob",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isAdd && _vm.formData.travelerName
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "公司名稱",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "companyName",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入公司名稱",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "請輸入公司名稱" },
                                  model: {
                                    value: _vm.formData.companyName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "companyName", $$v)
                                    },
                                    expression: "formData.companyName",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isAdd && _vm.formData.travelerName
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "聯絡電話",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "tel",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "請輸入聯絡電話" },
                                  model: {
                                    value: _vm.formData.tel,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "tel", $$v)
                                    },
                                    expression: "formData.tel",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isAdd && _vm.formData.travelerName
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "E-mail",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "email",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "請輸入 E-mail" },
                                  model: {
                                    value: _vm.formData.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "email", $$v)
                                    },
                                    expression: "formData.email",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isAdd && !_vm.formData.travelerName
                          ? _c("div", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                " *此報價單尚未建立旅客資料，請先請旅客填寫表單後再進行客戶資料編輯操作。 "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.isAdd || _vm.authEdit
            ? _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.handleSubmitForm },
                },
                [_vm._v(" 儲 存 ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: _vm.isAdd || _vm.authEdit ? "" : "danger" },
              on: {
                click: function ($event) {
                  _vm.internalVisible = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.isAdd ? "取 消" : "關 閉") + " ")]
          ),
        ],
        1
      ),
      _c("saleer-create-or-update-dialog", {
        attrs: {
          visible: _vm.dialogVisibleBySaleer,
          "initial-form-data": _vm.formDataBySaleer,
          "is-add": true,
          "auth-edit": _vm.isAdmin,
          "agency-code": _vm.formData.agencyCode,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisibleBySaleer = $event
          },
          "update:initialFormData": function ($event) {
            _vm.formDataBySaleer = $event
          },
          "update:initial-form-data": function ($event) {
            _vm.formDataBySaleer = $event
          },
          save: _vm.handleDialogSaveBySaleer,
          closed: _vm.handleDialogCloseBySaleer,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }